function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { actions as applicationActions } from 'researcher/application';
import { actions as userActions } from 'researcher/user';
// eslint-disable-next-line import/no-cycle
import { actions as accountActions } from 'shared/account';
import { localStorage } from 'shared/helper/storage';
import maskPhoneNumber from 'shared/helper/phoneMask';
import { getApiBaseUrl } from '../../shared/helper/request';
import * as c from './constants';
import resolveCurieRedirect from './components/resolveCurieRedirect';
var authEndpoint = '/api/auth';
var redirectUrl = '/api/account/redirect';

// Returned by the login endpoint when a Rubriq account has not confirmed its email
// address yet. `expired` means its link has outlived its 24 hours, which makes the
// account one that counts as never created: signing up again is the way back, and
// there is no point offering to resend. The login page handles both itself.
export var EMAIL_VERIFICATION_REQUIRED = 'email-verification-required';
export var EMAIL_VERIFICATION_EXPIRED = 'email-verification-expired';
var emailVerificationErrors = [EMAIL_VERIFICATION_REQUIRED, EMAIL_VERIFICATION_EXPIRED];

// Megatron answers with its own message keys; map the ones we know onto the terms
// the site translates them with.
var authMessages = _defineProperty(_defineProperty({}, EMAIL_VERIFICATION_REQUIRED, 'rubriq.verify-email-before-login-short'), EMAIL_VERIFICATION_EXPIRED, 'rubriq.verification-link-expired');
var authMessage = function authMessage(key) {
  return authMessages[key] || key;
};
export var loginUser = function loginUser(data, referringUrl, origin) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState, _ref) {
      var application, baseUrl, isChina, olderlang, hostname, cookieDomain, loginOrigin, response, json, isCurieTrialRedirect, normalised, _normalised;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            application = _ref.application;
            dispatch({
              type: c.USER_LOGIN_REQUESTED
            });
            _context.prev = 2;
            baseUrl = getApiBaseUrl();
            isChina = baseUrl.toLowerCase().includes('china');
            olderlang = isChina ? 'cn' : 'en'; // Setup Cookies for Know Domain SSO
            hostname = baseUrl.toLowerCase();
            cookieDomain = '';
            if (hostname.endsWith('.sqr.io')) {
              cookieDomain = '.sqr.io';
            } else {
              cookieDomain = '.aje.com';
            }
            if (cookieDomain) {
              document.cookie = "RubriqDomainUrl=rubriq; path=/; max-age=60; domain=".concat(cookieDomain, "; SameSite=None; Secure");
            }
            loginOrigin = origin || 'rubriq';
            _context.next = 13;
            return dispatch(application.post("".concat(authEndpoint, "/login?origin=").concat(loginOrigin), data));
          case 13:
            response = _context.sent;
            json = response.json || response.data || response;
            dispatch({
              type: c.USER_LOGIN_ATTEMPT_COMPLETED,
              json: json
            });
            if (json.language) {
              localStorage.set('language', json.language);
            }
            if (!(json.loggedIn && olderlang === json.language)) {
              _context.next = 21;
              break;
            }
            // If we're about to do a full-page navigation to a curie free trial,
            // skip loadUser/loadApplication — those API calls are wasted since
            // the browser is leaving this page immediately.
            isCurieTrialRedirect = referringUrl && (/\/c\/curiefreetrialchina/i.test(referringUrl) || /\/c\/curiefreetrial/i.test(referringUrl));
            if (!isCurieTrialRedirect) {
              dispatch(userActions.loadUser(json.user));
              dispatch(applicationActions.loadApplication({}));
            }
            return _context.abrupt("return", json);
          case 21:
            if (!(json.loggedIn && olderlang !== json.language)) {
              _context.next = 24;
              break;
            }
            // If we have a curie free trial referringUrl, honour it directly
            // instead of bouncing through /api/account/redirect which loses the destination.
            if (referringUrl && /\/c\/curiefreetrialchina/i.test(referringUrl)) {
              normalised = referringUrl.replace(/curiefreetrialchina/gi, 'CurieFreeTrialChina');
              resolveCurieRedirect("".concat(getApiBaseUrl()).concat(normalised));
            } else if (referringUrl && /\/c\/curiefreetrial/i.test(referringUrl)) {
              _normalised = referringUrl.replace(/curiefreetrial/gi, 'CurieFreeTrial');
              resolveCurieRedirect("".concat(getApiBaseUrl()).concat(_normalised));
            } else {
              window.location.href = "".concat(getApiBaseUrl()).concat(redirectUrl);
            }
            return _context.abrupt("return", {
              redirected: true,
              redirect_url: "".concat(getApiBaseUrl()).concat(redirectUrl)
            });
          case 24:
            if (!(!json.loggedIn && emailVerificationErrors.includes(json.error))) {
              _context.next = 27;
              break;
            }
            // The login page explains this one and offers either to resend the
            // link or to sign up again, so skip the generic error banner.
            dispatch({
              type: c.USER_EMAIL_VERIFICATION_REQUIRED,
              email: data.email,
              expired: json.error === EMAIL_VERIFICATION_EXPIRED
            });

            // Carries the address so that registerUser, which chains into this
            // when Megatron is older than the emailVerificationRequired flag,
            // can still offer to resend the link.
            return _context.abrupt("return", _objectSpread(_objectSpread({}, json), {}, {
              email: data.email,
              emailVerificationRequired: true
            }));
          case 27:
            if (!json.loggedIn) {
              dispatch(application.addMessage({
                type: 'error',
                message: authMessage(json.error) || 'login-form-error-message'
              }));
            }
            return _context.abrupt("return", json);
          case 31:
            _context.prev = 31;
            _context.t0 = _context["catch"](2);
            dispatch(application.addMessage({
              type: 'error',
              message: _context.t0.message || 'login-form-error-message'
            }));
            return _context.abrupt("return", {
              success: false,
              error: _context.t0.message || 'login-form-error-message'
            });
          case 35:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 31]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var sendOTP = function sendOTP(phoneNumber) {
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    return dispatch(application.post("/api/auth/otp/send", phoneNumber)).then(function (json) {
      var error = json.error,
        code = json.code;
      if (error) {
        dispatch({
          type: c.USER_REGISTRATION_REQUEST_FAILED
        });
        return dispatch(application.addMessage({
          type: 'error',
          message: error.code
        }));
      }
      var maskedPhone = maskPhoneNumber(typeof phoneNumber === 'string' ? phoneNumber : phoneNumber.phoneNumber, 2);
      var formattedPhone = "+86 ".concat(maskedPhone);
      return dispatch(application.addMessage({
        type: 'success',
        message: code,
        params: {
          phone: formattedPhone
        }
      }));
    });
  };
};
export var verifyUser = function verifyUser(email) {
  return function (dispatch, getState, _ref4) {
    var application = _ref4.application;
    return dispatch(application.post("".concat(authEndpoint, "/researcher_exists"), email)).then(function (json) {
      var error = json.error,
        researcherExists = json.researcherExists;
      if (error) {
        dispatch({
          type: c.USER_REGISTRATION_REQUEST_FAILED
        });
        return dispatch(application.addMessage({
          type: 'error',
          message: error.error
        }));
      }
      if (researcherExists) {
        dispatch(application.addMessage({
          type: 'error',
          message: 'email-already-exists'
        }));
        return false;
      }
      return true;
    });
  };
};
export var sendPhoneOtp = function sendPhoneOtp(_ref5) {
  var phoneNumber = _ref5.phoneNumber,
    countryCode = _ref5.countryCode;
  return function (dispatch, getState, _ref6) {
    var application = _ref6.application;
    return dispatch(application.post("".concat(authEndpoint, "/otp/send"), {
      phoneNumber: phoneNumber
    })).then(function (json) {
      // Error → show message, DO NOT allow OTP UI
      if (!json.success) {
        dispatch(application.addMessage({
          type: 'error',
          message: json.error.code // translation key
        }));
        return false;
      }

      // SUCCESS but still be strict
      if (json.code === 'OTP_SENT') {
        var maskedPhone = maskPhoneNumber(phoneNumber, 2);
        var formattedPhone = "".concat(countryCode, " ").concat(maskedPhone);
        dispatch(application.addMessage({
          type: 'success',
          message: json.code,
          // OTP_SENT
          params: {
            phone: formattedPhone
          }
        }));
        return true;
      }
      return false;
    });
  };
};
export var sendPhoneOtpV2 = function sendPhoneOtpV2(_ref7) {
  var phoneNumber = _ref7.phoneNumber,
    countryCode = _ref7.countryCode,
    platform = _ref7.platform,
    actionType = _ref7.actionType;
  return function (dispatch, getState, _ref8) {
    var application = _ref8.application;
    return dispatch(application.post("".concat(authEndpoint, "/otp/send-v2"), {
      phoneNumber: phoneNumber,
      platform: platform,
      actionType: actionType
    })).then(function (json) {
      // Error → show message, DO NOT allow OTP UI
      if (!json.success) {
        dispatch(application.addMessage({
          type: 'error',
          message: json.error.code // translation key
        }));
        return false;
      }
      if (json.code === 'OTP_SENT') {
        var maskedPhone = maskPhoneNumber(phoneNumber, 2);
        var formattedPhone = "".concat(countryCode, " ").concat(maskedPhone);
        dispatch(application.addMessage({
          type: 'success',
          message: json.code,
          // OTP_SENT
          params: {
            phone: formattedPhone
          }
        }));
        return true;
      }
      return false;
    });
  };
};
export var verifyPhoneOtp = function verifyPhoneOtp(_ref9) {
  var phoneNumber = _ref9.phoneNumber,
    code = _ref9.code;
  return function (dispatch, getState, _ref10) {
    var application = _ref10.application;
    return dispatch(application.post("".concat(authEndpoint, "/otp/verify"), {
      phoneNumber: phoneNumber,
      code: code
    })).then(function (json) {
      // Error case
      if (!json.success) {
        var _json$error;
        var remaining = (_json$error = json.error) === null || _json$error === void 0 || (_json$error = _json$error.meta) === null || _json$error === void 0 ? void 0 : _json$error.remainingAttempts;
        dispatch(application.addMessage({
          type: 'error',
          message: json.error.code,
          // translation key
          params: remaining !== undefined ? {
            remaining: remaining
          } : undefined
        }));
        return false;
      }
      // Verified
      dispatch(application.addMessage({
        type: 'success',
        message: json.code // PHONE_VERIFIED
      }));
      return true;
    });
  };
};
export var verifyPhoneOtpV2 = function verifyPhoneOtpV2(_ref11) {
  var phoneNumber = _ref11.phoneNumber,
    code = _ref11.code,
    actionType = _ref11.actionType;
  return function (dispatch, getState, _ref12) {
    var application = _ref12.application;
    return dispatch(application.post("".concat(authEndpoint, "/otp/verify-v2"), {
      phoneNumber: phoneNumber,
      code: code,
      actionType: actionType
    })).then(function (json) {
      // Error case
      if (!json.success) {
        var _json$error2;
        var remaining = (_json$error2 = json.error) === null || _json$error2 === void 0 || (_json$error2 = _json$error2.meta) === null || _json$error2 === void 0 ? void 0 : _json$error2.remainingAttempts;
        dispatch(application.addMessage({
          type: 'error',
          message: json.error.code,
          // translation key
          params: remaining !== undefined ? {
            remaining: remaining
          } : undefined
        }));
        return false;
      }
      // Verified
      dispatch(application.addMessage({
        type: 'success',
        message: json.code // PHONE_VERIFIED
      }));
      return true;
    });
  };
};
export var registerUser = function registerUser(userUpdateRequest, referringUrl, origin) {
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState, _ref13) {
      var application, json, _json, error, userDetails, _ref15, _userDetails$email, _userUpdateRequest$us, email;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            application = _ref13.application;
            dispatch({
              type: c.USER_REGISTRATION_REQUESTED
            });
            _context2.prev = 2;
            _context2.next = 5;
            return dispatch(application.post("".concat(authEndpoint, "/register"), userUpdateRequest));
          case 5:
            json = _context2.sent;
            _context2.next = 13;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);
            dispatch({
              type: c.USER_REGISTRATION_REQUEST_FAILED
            });
            dispatch(application.addMessage({
              type: 'error',
              message: 'generic-error-message'
            }));
            return _context2.abrupt("return", {
              loggedIn: false,
              error: _context2.t0.message || 'network-error',
              errorType: 'network_error'
            });
          case 13:
            _json = json, error = _json.error, userDetails = _json.userDetails;
            if (!error) {
              _context2.next = 18;
              break;
            }
            dispatch({
              type: c.USER_REGISTRATION_REQUEST_FAILED
            });
            dispatch(application.addMessage({
              type: 'error',
              message: authMessage(error.error)
            }));
            return _context2.abrupt("return", {
              loggedIn: false,
              error: error.error,
              errorType: 'registration_error'
            });
          case 18:
            if (!json.emailVerificationRequired) {
              _context2.next = 22;
              break;
            }
            email = (_ref15 = (_userDetails$email = userDetails === null || userDetails === void 0 ? void 0 : userDetails.email) !== null && _userDetails$email !== void 0 ? _userDetails$email : userUpdateRequest === null || userUpdateRequest === void 0 || (_userUpdateRequest$us = userUpdateRequest.userDetails) === null || _userUpdateRequest$us === void 0 ? void 0 : _userUpdateRequest$us.email) !== null && _ref15 !== void 0 ? _ref15 : null;
            dispatch({
              type: c.USER_EMAIL_VERIFICATION_REQUIRED,
              email: email
            });
            return _context2.abrupt("return", {
              emailVerificationRequired: true,
              emailVerificationPending: Boolean(json.emailVerificationPending),
              email: email
            });
          case 22:
            return _context2.abrupt("return", dispatch(loginUser({
              email: userDetails.email,
              password: userDetails.password
            }, referringUrl, origin)));
          case 23:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 8]]);
    }));
    return function (_x4, _x5, _x6) {
      return _ref14.apply(this, arguments);
    };
  }();
};
export var resendVerificationEmail = function resendVerificationEmail(email) {
  return function (dispatch, getState, _ref16) {
    var application = _ref16.application;
    return dispatch(application.post("".concat(authEndpoint, "/resend-verification-email"), {
      email: email
    })).then(function () {
      return (
        // Megatron answers the same way whether or not the address is waiting
        // to be verified, so that an account cannot be probed for. Say the same
        // thing back rather than implying the address is registered.
        dispatch(application.addMessage({
          type: 'success',
          message: 'rubriq.verification-link-on-its-way'
        }))
      );
    });
  };
};
export var resetPassword = function resetPassword(data) {
  return function (dispatch, getState, _ref17) {
    var application = _ref17.application;
    dispatch({
      type: c.USER_RESET_PASSWORD_REQUESTED
    });
    return dispatch(application.post("".concat(authEndpoint, "/reset-password"), data)).then(function (json) {
      dispatch({
        type: c.USER_RESET_PASSWORD_REQUEST_COMPLETED
      });
      return json;
    });
  };
};
export var loadAuthentication = function loadAuthentication(foundUsOptions) {
  return function (dispatch) {
    return dispatch(accountActions.loadAccount('/api/account', foundUsOptions));
  };
};
export var requestPasswordReset = function requestPasswordReset(_ref18) {
  var email = _ref18.email;
  return function (dispatch, getState, _ref19) {
    var application = _ref19.application;
    dispatch({
      type: c.USER_PASSWORD_RESET_REQUESTED
    });
    return dispatch(application.post("".concat(authEndpoint, "/request-password-reset"), {
      email: email
    })).then(function (json) {
      dispatch({
        type: c.USER_PASSWORD_RESET_REQUEST_COMPLETED
      });
      if (json.error) {
        dispatch(application.addMessage({
          type: 'error',
          message: json.error
        }));
      }
      return json;
    });
  };
};
export var startWeChatLogin = function startWeChatLogin() {
  return function (dispatch, getState, _ref20) {
    var application = _ref20.application;
    dispatch({
      type: c.QR_CODE_REQUESTED
    });
    return dispatch(application.post("/api/auth/wechat-login")).then(function (_ref21) {
      var error = _ref21.error,
        loginCode = _ref21.loginCode,
        ticket = _ref21.ticket,
        url = _ref21.url;
      var result = {
        error: error,
        loginCode: loginCode,
        qrCodeUrl: null
      };
      if (error) {
        dispatch(application.addMessage({
          type: 'error',
          message: error
        }));
      }
      if (url && ticket) {
        result.qrCodeUrl = "https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=".concat(ticket);
      }
      dispatch({
        type: c.QR_CODE_RETRIEVED,
        qrCodeUrl: result.qrCodeUrl,
        loginCode: loginCode
      });
      return result;
    });
  };
};
export var checkWeChatLogin = function checkWeChatLogin() {
  return function (dispatch, getState, _ref22) {
    var _getState$authenticat;
    var application = _ref22.application;
    var queryParameter = (_getState$authenticat = getState().authentication.loginCode) !== null && _getState$authenticat !== void 0 ? _getState$authenticat : '';
    return dispatch(application.get("/api/auth/wechat-login/".concat(queryParameter))).then(function (_ref23) {
      var error = _ref23.error,
        loggedIn = _ref23.loggedIn,
        redirectUri = _ref23.redirectUri,
        user = _ref23.user;
      if (error) {
        dispatch(application.addMessage({
          type: 'error',
          message: error
        }));
      }
      if (loggedIn) {
        dispatch(userActions.loadUser(user));
        dispatch(applicationActions.loadApplication({}));
      }
      if (redirectUri) {
        dispatch({
          type: c.WECHAT_REDIRECT_RECEIVED,
          redirectUri: redirectUri
        });
      }
      return {
        error: error
      };
    });
  };
};